module.exports = __webpack_public_path__ + "static/gothic-a1-v8-latin-regular-b3474c42019f8d9e720b9af0f07d83a0.woff2";